export const environment = {
  production: false,
  // Payment processor configuration
  get payrix() {
    // Payrix configuration
    const context = JSON.parse(
      localStorage.getItem('fspDiscoveryFlightContext') || '{}',
    );
    return {
      baseUrl: context.payrixBaseUrl,
      payFieldsScriptUrl: context.payrixPayFieldsScriptUrl,
      apiKey: context.payrixApiKey,
    };
  },
  get apiUrl() {
    const context = JSON.parse(
      localStorage.getItem('fspDiscoveryFlightContext') || '{}',
    );
    return context.discoveryFlightApiUrl || 'http://localhost:3000';
  },
  get apiEnvironment() {
    const context = JSON.parse(
      localStorage.getItem('fspDiscoveryFlightContext') || '{}',
    );
    return context.apiEnvironment;
  },
  get recaptchaSiteKey() {
    const context = JSON.parse(
      localStorage.getItem('fspDiscoveryFlightContext') || '{}',
    );
    return context.recaptchaKey;
  },
  recaptchaEnabled: true,
  get subscriptionKey() {
    const context = JSON.parse(
      localStorage.getItem('fspDiscoveryFlightContext') || '{}',
    );
    return context.subscriptionKey;
  },
};
